import script from "./termsofservice.vue?vue&type=script&setup=true&lang=js"
export * from "./termsofservice.vue?vue&type=script&setup=true&lang=js"

import "./termsofservice.vue?vue&type=style&index=0&id=7ac20cb4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\23586\\Desktop\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ac20cb4"]])

export default __exports__